<template>
  <div v-if="items" class="flex flex-wrap -mb-8 -mr-6 p-8">
    <text-input
      v-for="(language, key) in items"
      :key="key"
      v-model="language.value"
      class="pb-8 pr-6 w-full lg:w-1/2"
      :label="language.label"
      :error="form.errors['name.' + language.id]"
      :required="true"
    />
    <select-multiple
      v-model="form.types" :default-options="types" :error="form.errors.types"
      class="pb-8 pr-6 w-full lg:w-1/2" label="Types"
      :required="true"
    />
    <checkbox
      v-model="form.empty_field" :error="form.errors.empty_field"
      class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('languages.empty_field')"
    />
    <checkbox
      v-model="form.for_volunteer" :error="form.errors.for_volunteer"
      class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('global.for_volunteer')"
    />
  </div>
</template>
<script>
import TextInput from '@/Shared/TextInput'
import Checkbox from '@/Shared/Checkbox'
import SelectMultiple from '@/Shared/SelectMultiple'

export default {
  components: {
    Checkbox,
    TextInput,
    SelectMultiple,
  },
  props: ['formData', 'types'],
  data() {
    return {
      items: [],
      languages: this.$languages.getLanguages(),
    }
  },
  computed: {
    form() {
      return this.formData
    },
  },
  watch: {
    items: {
      handler(newValue) {
        let obj = {}
        for (let item in this.items) {
          obj[this.items[item].id] = this.items[item].value
        }
        this.form.name = obj
      },
      deep: true,
    },
  },
  mounted() {
    let formLanguages = this.form.name
    for (let language in this.languages) {
      let obj = {
        id: this.languages[language].value,
        label: this.languages[language].label,
        value: formLanguages[this.languages[language].value] ? formLanguages[this.languages[language].value] : '',
      }
      this.items.push(obj)
    }
  },
}
</script>
